<template>
  <div class="input-page">
    <div class="container">
      <div class="title">Type your UserID</div>
      <div class="code-wrapper" @click="focusInput">
        <div
          v-for="(char, index) in displayCodes"
          :key="index"
          class="code-box"
          :class="{ active: focusedIndex === index }"
        >
          {{ char }}
          <span v-if="focusedIndex === index && !char" class="cursor"></span>
        </div>
        <input
          ref="codeInput"
          v-model="inputValue"
          maxlength="4"
          autocomplete="off"
          type="tel"
          inputmode="text"
          @input="handleInput"
          @focus="handleFocus"
          @blur="handleBlur"
          class="hidden-input"
        />
      </div>
      <el-button type="primary" size="large" @click="handleJump" :disabled="!isComplete">
        Go to Verify
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputPage',
  data() {
    return {
      inputValue: '',
      isFocused: false
    }
  },
  computed: {
    displayCodes() {
      const codes = this.inputValue.split('')
      return Array(4).fill('').map((_, i) => codes[i] || '')
    },
    focusedIndex() {
      if (!this.isFocused) return -1
      return Math.min(this.inputValue.length, 3)
    },
    isComplete() {
      return this.inputValue.length === 4
    }
  },
  methods: {
    focusInput() {
      this.$refs.codeInput.focus()
    },
    handleInput() {
      // 只允许数字
      // this.inputValue = this.inputValue.replace(/\D/g, '').slice(0, 4)
    },
    handleFocus() {
      this.isFocused = true
    },
    handleBlur() {
      this.isFocused = false
    },
    handleJump() {
      if (!this.isComplete) {
        this.$message.warning('Enter the 4-digit verification code')
        return
      }
      // this.$router.push(`/${this.inputValue}`)
      var path = this.inputValue.slice(0,1)+"/"+ this.inputValue.slice(1,4);
      window.location = `http://fz0.pw/`+ path;

    }
  }
}
</script>

<style lang="less" scoped>
.input-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 430px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}

.code-wrapper {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
}

.code-box {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.3s;
  position: relative;
}

.code-box.active {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.cursor {
  position: absolute;
  width: 2px;
  height: 24px;
  background-color: #409eff;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}

.hidden-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

/deep/ .el-button {
  width: 100%;
  max-width: 200px;
  height: 40px;
  font-size: 14px;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .input-page {
    padding: 16px;
    align-items: flex-start;
    padding-top: 15vh;
  }

  .container {
    padding: 24px 20px;
  }

  .title {
    font-size: 18px;
    margin-bottom: 24px;
  }

  .code-wrapper {
    gap: 12px;
    margin-bottom: 24px;
  }

  .code-box {
    width: 55px;
    height: 55px;
    font-size: 22px;
  }

  .cursor {
    height: 22px;
  }

  /deep/ .el-button {
    max-width: none;
  }
}

@media (max-width: 375px) {
  .code-wrapper {
    gap: 10px;
  }

  .code-box {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }

  .cursor {
    height: 20px;
  }
}
</style>
